export default __webpack_public_path__ + "static/media/Jalsa2.514e514c.mp3";